import { createSlice } from '@reduxjs/toolkit';
import {
  deleteAreaPlanThunk,
  getAreaPlansThunk,
  getProjectAreaplansThunk,
  saveAreaplanThunk,
  saveNewAreaplanVersionThunk,
  updateAreaPlanThunk,
} from '../thunks/areaPlanThunks';

export const areaPlanningSlice = createSlice({
  name: 'areaPlanning',
  initialState: {
    areaplans: [],
    selectedAreaPlanId: null,
    versionId: null,
    versionName: null,
    isLoading: false,
  },
  reducers: {
    selectAreaPlan: (state, action) => {
      state.selectedAreaPlanId = action.payload;
    },
    setVersionId: (state, action) => {
      state.versionId = action.payload;
    },
    setVersionName: (state, action) => {
      state.versionName = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET
    builder
      .addCase(getAreaPlansThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAreaPlansThunk.fulfilled, (state, action) => {
        state.areaplans = action.payload;
        state.isLoading = false;
      })
      .addCase(getAreaPlansThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      // GET PROJECTAREA PLANS
      .addCase(getProjectAreaplansThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProjectAreaplansThunk.fulfilled, (state, action) => {
        state.areaplans = action.payload;
        state.isLoading = false;
      })
      .addCase(getProjectAreaplansThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      // POST
      .addCase(saveAreaplanThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(saveAreaplanThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveAreaplanThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      // UPDATE
      .addCase(updateAreaPlanThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateAreaPlanThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateAreaPlanThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      // CREATE NEW VERSION
      .addCase(saveNewAreaplanVersionThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(saveNewAreaplanVersionThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveNewAreaplanVersionThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      // DELETE
      .addCase(deleteAreaPlanThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteAreaPlanThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteAreaPlanThunk.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { selectAreaPlan, setVersionId, setVersionName } =
  areaPlanningSlice.actions;

// SELECTORS
export const getAreaPlans = (state) => {
  return state.areaPlanning.areaplans;
};

export const getSelectedAreaPlanId = (state) => {
  return state.areaPlanning.selectedAreaPlanId;
};

export const getSelectedAreaPlan = (state) => {
  if (state.areaPlanning.selectedAreaPlanId === null) return null;

  return state.areaPlanning.areaplans.find(
    (areaPlan) => areaPlan.id === state.areaPlanning.selectedAreaPlanId
  );
};

export const getVersionId = (state) => {
  return state.areaPlanning.versionId;
};

export const getVersionName = (state) => {
  return state.areaPlanning.versionName;
};

export const getIsLoading = (state) => {
  return state.areaPlanning.isLoading;
};
